import { IPage } from "../../shared/components/definitions/page/IPage";
import { MiProyectoRender } from "../../shared/components/modulos/proyectos/detail/MiProyectoRender";

/** Vista del agricultor sobre sus propios proyectos (mockup PM_C_Agricultor). Solo lectura. */
export class MisProyectosPage implements IPage {
  private _render: MiProyectoRender | null = null;

  render(pageContent: HTMLDivElement): void {
    this._render = new MiProyectoRender();
    pageContent.innerHTML = this._render.render();
    this._render.connect();
  }

  dispose(): void {
    this._render?.dispose();
    this._render = null;
  }
}
